import api from "./api";

export const dashboard = async () => {
  const { data } = await api.get("/dashboard");
  return data;
};
export const causelist = async (payload) => {
  const { data } = await api.post("/cause_list", payload);
  return data;
};
export const adminCauseAction = async (params) => {
  const { data } = await api.post("/admin_cause_action", params);
  return data;
};
export const pcauselist = async (payload) => {
  const { data } = await api.post("/admin_published_cause", payload);
  return data;
};
export const finishedcauselist = async (payload) => {
  const { data } = await api.post("/admin_finished_cause", payload);
  return data;
};
export const reordercauselist = async (payload) => {
  const { data } = await api.post("/reorder_cause", payload);
  return data;
};
export const donationtransfer = async (payload) => {
  const { data } = await api.post("/complete_donation_transfer", payload);
  return data;
};
export const vollist = async (payload) => {
  const { data } = await api.post("/volunteer_request_list", payload);
  return data;
};
export const userlist = async (payload) => {
  const { data } = await api.post("/user_list", payload);
  return data;
};
export const deleteuser = async (payload) => {
  const { data } = await api.post("/delete_user", payload);
  return data;
};
export const pendingvol = async (payload) => {
  const { data } = await api.post("/volunteer_request_list", payload);
  return data;
};
export const approveVolunteer = async (payload) => {
  const { data } = await api.post("/volunteer_request_action", payload);
  return data;
};
export const donationlist = async (payload) => {
  const { data } = await api.post("/cause_donation_list", payload);
  return data;
};

export const profile = async () => {
  const { data } = await api.get("/get_profile");
  return data;
};

export const updateProfile = async (payload) => {
  const { data } = await api.put("/update_profile", payload);
  return data;
};
export const changePassword = async (payload) => {
  const { data } = await api.post("/change_password", payload);
  return data;
};
export const timeline = async () => {
  const { data } = await api.get("/timer");
  return data;
};
export const todayreading = async () => {
  const { data } = await api.get("/today-reading");
  return data;
};

export const getbible = async ({ book_name, chapter, bible_version, page }) => {
  const payload = {};

  if (book_name) payload.book_name = book_name;
  if (chapter) payload.chapter = chapter;
  if (bible_version) payload.bible_version = bible_version;
  if (page) payload.page = page;

  console.log(payload);
  const res = await api.post("/bibles", payload);
  console.log(res);
  return res.data;
};

export const dropdown = async () => {
  const { data } = await api.get("/bible-drop-down");
  return data;
};

export const addnotes = async (payload) => {
  const { data } = await api.post("/notes-management", payload);
  return data;
};
export const getnotes = async () => {
  const { data } = await api.get("/notes-management");
  return data;
};
export const deletenotes = async (id) => {
  const { data } = await api.delete(`/notes-management?id=${id}`);
  return data;
};
export const favouritenote = async (payload) => {
  const { data } = await api.put(`/notes-management`, payload);
  return data;
};
export const getcalender = async () => {
  const { data } = await api.get("/calendar-management");
  return data;
};
export const addevent = async (payload) => {
  const { data } = await api.post("/calendar-management", payload);
  return data;
};
export const editevent = async (payload) => {
  const { data } = await api.put(`/calendar-management`, payload);
  return data;
};
export const deleteevent = async (id) => {
  const { data } = await api.delete(`/calendar-management?id=${id}`);
  return data;
};
export const getprayerstate = async () => {
  const { data } = await api.get("/prayer-statistics");
  return data;
};
export const getactiveprayer = async () => {
  const { data } = await api.get("/active-prayer");
  return data;
};
export const getanswerprayer = async () => {
  const { data } = await api.get("/answered-prayer");
  return data;
};
export const addprayer = async (payload) => {
  const { data } = await api.post("/prayer-management", payload);
  return data;
};
export const editprayer = async (payload) => {
  const { data } = await api.put(`/prayer-management`, payload);
  return data;
};
export const deleteprayer = async (id) => {
  const { data } = await api.delete(`/prayer-management?id=${id}`);
  return data;
};
export const addanswerprayer = async (payload) => {
  const { data } = await api.post(`/answer`, payload);
  return data;
};
export const getjournal = async () => {
  const { data } = await api.get("/journal-management");
  return data;
};
export const addjournal = async (payload) => {
  const { data } = await api.post("/journal-management", payload);
  return data;
};
export const getbibleversion = async () => {
  const { data } = await api.get("/bible-versions");
  return data;
};
export const getverse = async (verses, bible_version) => {
  console.log("verse2", verses);
  const payload = {};
  console.log("get");
  if (verses) payload.verses = verses;
  payload.bible_version = bible_version;
  console.log("pay", payload);
  const { data } = await api.post("/verse-filter", payload);
  return data;
};

// export const getmemories = async ({ info }) => {
//   const params = new URLSearchParams();

//   if (info?.fdate) params.append("from_date", info.fdate);
//   if (info?.tdate) params.append("till_date", info.tdate);
//   if (info?.type) params.append("memory_type", info.type);
//   if (info?.lid) params.append("last_id", info.lid);

//   const query = params.toString();
//   const url = `/Child-Memories-Imgs${query ? `?${query}` : ""}`;

//   console.log("request url:", url);

//   const { data } = await api.get(url);
//   return data;
// };
